<div class="row">
  <div class="col-12">
    <form [formGroup]="powerUserModifyForm">
      <div class="row" class="row border Page-Header">
        <div class="col-12">
          <h6 class="HeadContent">Edit Power User</h6>
        </div>
      </div>

      <div class="row pt-1">
        <div class="col-12">
          <div class="row">
            <div
              class="col-6"
              [ngClass]="{
                'my-disable': powerUserModifyForm.value.status == 'Disabled'
              }"
            >
              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">First Name</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <input
                    type="text"
                    id="name"
                    class="form-control form-control-sm input-txt"
                    formControlName="firstName"
                    (ngModelChange)="Editformvalidation()"
                    [ngClass]="{'input-invalid': powerUserModifyForm.get('firstName')?.touched && powerUserModifyForm.get('firstName')?.invalid}"
                    required
                  />
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <!-- <div class="p-0 label-red">*</div>          -->
                    <div class="p-0">Middle Name</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <input
                    type="text"
                    class="form-control form-control-sm input-txt"
                    formControlName="middleName"
                    (ngModelChange)="Editformvalidation()"
                  />
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">Last Name</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <input
                    type="text"
                    class="form-control form-control-sm input-txt"
                    formControlName="lastName"
                    [ngClass]="{'input-invalid': powerUserModifyForm.get('lastName')?.touched && powerUserModifyForm.get('lastName')?.invalid}"
                    (ngModelChange)="Editformvalidation()"
                    required
                  />
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <!-- <div class="p-0 label-red">*</div>          -->
                    <div class="p-0">Full Name</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <input
                    type="text"
                    class="form-control form-control-sm input-txt"
                    formControlName="fullName"
                  />
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">Email Address</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <input
                    type="text"
                    [attr.disabled]="true"
                    class="form-control form-control-sm input-txt"
                    formControlName="emailAddress"
                    (ngModelChange)="Editformvalidation()"
                    [ngClass]="{'input-invalid': powerUserModifyForm.get('emailAddress')?.touched && powerUserModifyForm.get('emailAddress')?.invalid}"
                    required
                  />
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-12">
                  <div class="row">
                    <div class="col-4 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">Primary Phone Number</div>
                      </div>
                    </div>

                    <div class="col-8 pt-1 px-1">
                      <div
                        class="p-0 border"
                        style="
                          padding-top: 4px;
                          width: 100%;
                          text-overflow: ellipsis;
                          border-radius: 4px;
                          height: 45px;
                        "
                      >
                        <div class="d-flex">
                          <div class="p-0 px-1 pt-1">
                            <select
                              class="form-control form-control-sm inputfield-txt"
                              [ngClass]="{
                                'borderview1': countrynumber1flag === true,
                                'input-invalid': powerUserModifyForm.get('countryCode1')?.touched && powerUserModifyForm.get('countryCode1')?.invalid
                              }"
                              formControlName="countryCode1"
                              (ngModelChange)="selectcountrycode()"
                              required
                            >
                              <option selected value="" hidden>
                                Country Code*
                              </option>
                              <option
                                class="border-bottom"
                                *ngFor="let code of countryCode"
                                [value]="code.Code"
                              >
                                {{ code.Name }}
                              </option>
                            </select>
                          </div>
                          <div class="p-0 px-1 pt-1">
                            <input
                              type="number"
                              [ngClass]="{
                                'borderview1': phonenumber1flag === true,
                                'input-invalid': powerUserModifyForm.get('primaryPhoneNumber')?.touched && powerUserModifyForm.get('primaryPhoneNumber')?.invalid
                              }"
                              oninput="this.value=this.value.slice(0,this.maxLength)"
                              formControlName="primaryPhoneNumber"
                              (ngModelChange)="selectphonemnumber1()"
                              maxlength="10"
                              placeholder="Phone Number 1*"
                              class="form-control form-control-sm inputfield-txt1"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-12">
                  <div class="row">
                    <div class="col-4 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <!-- <div class="p-0 label-red">*</div>          -->
                        <div class="p-0">Secondary Phone Number</div>
                      </div>
                    </div>

                    <div class="col-8 pt-1 px-1">
                      <div
                        class="p-0 border"
                        style="
                          padding-top: 4px;
                          width: 100%;
                          text-overflow: ellipsis;
                          border-radius: 4px;
                          height: 45px;
                        "
                      >
                        <div class="d-flex">
                          <div class="p-0 px-1 pt-1">
                            <select
                              class="form-control form-control-sm inputfield-txt"
                              [ngClass]="{
                                borderview1: countrynumber2flag == true
                              }"
                              formControlName="countryCode2"
                              (ngModelChange)="selectcountrycode1()"
                            >
                              <option selected value="" hidden>
                                Country Code
                              </option>
                              <option
                                class="border-bottom"
                                *ngFor="let code of countryCode"
                                [value]="code.Code"
                              >
                                {{ code.Name }}
                              </option>
                            </select>
                          </div>
                          <div class="p-0 px-1 pt-1">
                            <input
                              type="number"
                              [ngClass]="{
                                borderview1: phonenumber2flag == true
                              }"
                              oninput="this.value=this.value.slice(0,this.maxLength)"
                              formControlName="secondaryPhoneNumber"
                              (ngModelChange)="selectphonemnumber2()"
                              maxlength="10"
                              placeholder="Phone Number 2"
                              class="form-control form-control-sm inputfield-txt1"
                            />
                          </div>
                          <!-- oninput="this.value=this.value.slice(0,this.maxLength)" -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">Primary Language</div>
                  </div>
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0">(Mother Tongue)</div>
                  </div>
                </div>
                <div class="col-8 pt-2 px-1">
                  <select
                    class="form-control form-control-sm input-txt"
                    formControlName="PrimaryLanguage"
                    [ngClass]="{'input-invalid': powerUserModifyForm.get('PrimaryLanguage')?.touched && powerUserModifyForm.get('PrimaryLanguage')?.invalid}"
                    (ngModelChange)="Editformvalidation()"
                  >
                    <option
                      class="border-bottom"
                      *ngFor="let lan of LanguageType"
                      value="{{ lan.Code }}"
                    >
                      {{ lan.Name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">Education Qualifications</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <select
                    class="form-control form-control-sm input-txt"
                    formControlName="educationQualification"
                    [ngClass]="{'input-invalid': powerUserModifyForm.get('educationQualification')?.touched && powerUserModifyForm.get('educationQualification')?.invalid}"
                    (ngModelChange)="Editformvalidation()"
                  >
                    <option
                      class="border-bottom"
                      *ngFor="let eq of educationalQualifications"
                      value="{{ eq.Code }}"
                    >
                      {{ eq.Name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">Select Years of Experience</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <select
                    class="form-control form-control-sm input-txt"
                    formControlName="Experience"
                    [ngClass]="{'input-invalid': powerUserModifyForm.get('Experience')?.touched && powerUserModifyForm.get('Experience')?.invalid}"
                    (ngModelChange)="Editformvalidation()"
                  >
                    <option
                      class="border-bottom"
                      *ngFor="let experience of experienceType"
                      value="{{ experience.Code }}"
                    >
                      {{ experience.Name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <!-- <div class="p-0 label-red">*</div>          -->
                    <div class="p-0">Experience Description</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <textarea
                    maxlength="4000"
                    formControlName="Comment_Text"
                    (ngModelChange)="Editformvalidation()"
                    class="form-control input-txt1"
                  ></textarea>
                </div>
              </div>
            </div>

            <div
              class="col-6"
              [ngClass]="{
                'my-disable': powerUserModifyForm.value.status == 'Disabled'
              }"
            >
              <div class="row">
                <div class="col-12">
                  <div class="row pt-2">
                    <div class="col-3 text-right pr-0 pt-1 pl-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">Status</div>
                      </div>
                    </div>
                    <div class="col-3 px-1">
                      <input
                        type="text"
                        [attr.disabled]="true"
                        class="form-control form-control-sm input-txt-status"
                        formControlName="status"
                        [ngClass]="{'input-invalid': powerUserModifyForm.get('status')?.touched && powerUserModifyForm.get('status')?.invalid}"
                        (ngModelChange)="Editformvalidation()"
                      />
                    </div>
                    <div class="col-5">
                      <div class="row">
                        <div class="col-12">
                          <div class="d-flex">
                            <div class="px-1">
                              <button
                                (click)="changePowerUserStatus()"
                                type="button"
                                class="btn btn-sm bg-light border"
                              >
                                Change Status
                              </button>
                            </div>
                            <div class="px-1">
                              <button
                                type="button"
                                class="btn btn-sm bl-btn"
                                [disabled]="RoleInd == 'N'"
                                (click)="onClickAssignRoleButton()"
                              >
                                Assign Role
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">Address Line 1</div>
                      </div>

                    </div>
                    <div class="col-7 pt-1 px-1">
                      <input
                        type="text"
                        class="form-control form-control-sm input-txt"
                        formControlName="addressLine1"
                        [ngClass]="{'input-invalid': powerUserModifyForm.get('addressLine1')?.touched && powerUserModifyForm.get('addressLine1')?.invalid}"
                        (ngModelChange)="Editformvalidation()"
                        required
                      />
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <!-- <div class="p-0 label-red">*</div>          -->
                        <div class="p-0">Address Line 2</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <input
                        type="text"
                        class="form-control form-control-sm input-txt"
                        formControlName="addressLine2"
                        (ngModelChange)="Editformvalidation()"
                      />
                    </div>
                  </div>
                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0">Address Line 3</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <input
                        type="text"
                        class="form-control form-control-sm input-txt"
                        formControlName="PostOffice"
                        (ngModelChange)="Editformvalidation()"
                      />
                    </div>
                  </div>
                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">City</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <input
                        type="text"
                        class="form-control form-control-sm input-txt"
                        [ngClass]="{'input-invalid': powerUserModifyForm.get('City')?.touched && powerUserModifyForm.get('City')?.invalid}"
                        formControlName="City"
                        (ngModelChange)="Editformvalidation()"
                        required
                      />
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">PIN Code</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <input
                        type="text"
                        class="form-control form-control-sm input-txt"
                        formControlName="PINcode"
                        [ngClass]="{'input-invalid': powerUserModifyForm.get('PINcode')?.touched && powerUserModifyForm.get('PINcode')?.invalid}"
                        (ngModelChange)="Editformvalidation()"
                        required
                      />
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">Country</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <select
                        class="form-control form-control-sm input-txt"
                        formControlName="Country"
                        [ngClass]="{'input-invalid': powerUserModifyForm.get('Country')?.touched && powerUserModifyForm.get('Country')?.invalid}"
                        (change)="onCountryChange($event)"
                      >
                        <option
                          class="border-bottom"
                          *ngFor="let country of countryName"
                          value="{{ country.Code }}"
                        >
                          {{ country.Name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">State</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <select
                        class="form-control form-control-sm input-txt"
                        formControlName="State"
                        [ngClass]="{'input-invalid': powerUserModifyForm.get('State')?.touched && powerUserModifyForm.get('State')?.invalid}"
                        (ngModelChange)="Editformvalidation()"
                      >
                      <option value="null"> </option>
                        <option
                          class="border-bottom"
                          *ngFor="let state of State"
                          value="{{ state.Code }}"
                        >
                          {{ state.Name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-3">
                          <div class="d-flex">
                            <div class="p-0 HeadContent2">Power User Roles</div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">

                          <div class="row">

                            <div class="col-12 scroll-style">
                              <div class="table-responsive">
                                <table
                                  class="table table-bordered table-hover"
                                  style="margin-bottom: 0"
                                >
                                  <thead>
                                    <tr class="table-active">
                                      <th class="col-md-2">Role</th>
                                      <th class="col-md-2">Subjects</th>
                                      <th scope="col">Role Status</th>
                                      <th scope="col">Start Date</th>
                                      <th scope="col">End Date</th>
                                      <th scope="col">Assigned By</th>
                                      <th scope="col">Approved By</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      *ngFor="
                                        let s of selectedPowerUserRole;
                                        let i = index
                                      "
                                      (click)="clickPoweruseredit(s, i)"
                                    >
                                      <td>{{ s.Power_User_Role_Type_Name }}</td>
                                      <td>{{ s.Subjects }}</td>
                                      <td>
                                        {{ s.Power_User_Role_Status_Type_Name }}
                                      </td>
                                      <td>
                                        {{ s.Start_Date | date : "dd/MM/yyyy" }}
                                      </td>
                                      <td>
                                        {{ s.End_Date | date : "dd/MM/yyyy" }}
                                      </td>
                                      <td>{{ s.assignedBy }}</td>
                                      <td>{{ s.approvedBy }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <!-- </div>

                            </div> -->
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="row py-2">
                <div class="col-2"></div>
                <div class="col-10">
                  <div class="d-flex">
                    <div class="px-1">
                      <!-- ||(powerUserModifyForm.valid&&!DataUpdateFlag) -->
                      <button
                        type="submit"
                        class="btn btn-sm bl-btn"
                        [disabled]="
                          powerUserModifyForm.invalid ||
                          (powerUserModifyForm.valid && !DataUpdateFlag) ||
                          phonenumber1flag ||
                            phonenumber2flag ||
                            countrynumber1flag ||
                            countrynumber2flag
                        "
                        (click)="saveOnClick()"
                      >
                        Save
                      </button>
                    </div>
                    <div class="px-1">
                      <button
                        type="button"
                        class="btn btn-sm bg-light border"
                        (click)="Cancelbutton()"
                      >
                        Cancel
                      </button>
                    </div>

                    <div
                      class="px-1"
                      *ngIf="powerUserModifyForm.value.status == 'New'"
                    >
                      <button
                        type="button"
                        class="btn btn-sm bg-light border"
                        [disabled]="
                        PowerUserID === currentLoggedInUser
                        "
                        (click)="Clickpassword()"
                      >
                        Resend Password/Activation Link
                      </button>
                    </div>
                    <div
                      class="px-1"
                      *ngIf="
                        powerUserModifyForm.value.status ==
                          'Password To Be Reset' ||
                        powerUserModifyForm.value.status == 'Active'
                      "
                    >
                      <button
                        type="button"
                        class="btn btn-sm bg-light border"
                        [disabled]="PowerUserID === currentLoggedInUser"
                        (click)="Clickrestpassword()"
                      >
                        Resend Password/Activation Link
                      </button>
                    </div>
                    <div
                      class="px-1"
                      *ngIf="powerUserModifyForm.value.status == 'Active'"
                    >
                      <button
                        type="button"
                        class="btn btn-sm bg-light border"
                        [disabled]="
                          PowerUserID === currentLoggedInUser
                        "
                        (click)="ClickDeactivate()"
                      >
                        Deactivate Immediately
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="modal fade show Model_popup1" *ngIf="Assignroletouser">
  <div class="modal-dialog modal-dialog-centered modal-dialog-StudyMaterial">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Assign Roles to Power User
        </h6>
        <button
          type="button"
          class="close"
          (click)="one.OnClickCancelButton()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-assign-roles-to-power-user
          #one
          (Closepopup)="Closepopup($event)"
        ></app-assign-roles-to-power-user>
      </div>
    </div>
  </div>
</div>
<!-- <div class="modal fade  show Model_popup1" *ngIf="passwordflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-StudyMaterial">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Set Password</h6>
        <button type="button" class="close" (click)="Clickpassword()"
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>

      <div class="modal-body px-3 py-0">

      <app-user-set-password></app-user-set-password>
      </div>
    </div>
  </div>
</div> -->
<div
  class="modal fade show modal-dialog-centered"
  style="padding-right: 4px; display: block; background-color: #00000075"
  *ngIf="cancelalertflag"
>
  <div class="modal-dialog modal-dialog-alert1 modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button
          type="button"
          class="close"
          style="padding-right: 20px; font-size: 30px; outline: 0"
          (click)="AlertCancelpopup()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Do you want to Discard or Continue Editing ?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bg-light border"
                  (click)="DiscardChanges()"
                >
                  Discard Changes
                </button>
              </div>
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bl-btn"
                  (click)="AlertCancelpopup()"
                >
                  Continue Editing
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
